import interact from "interactjs";

function dragMoveListener(event) {
    const { target } = event;
    // keep the dragged position in the data-x/data-y attributes
    const x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
    const y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

    // translate the element
    target.style.webkitTransform = target.style.transform = `translate(${x}px, ${y}px)`;

    // update the position attributes
    target.setAttribute("data-x", x);
    target.setAttribute("data-y", y);
}

export const icon = function (el) {
    setTimeout(function () {
        const text = el.querySelector(".icon__text");
        const w = text.getBoundingClientRect().width;
        el.setAttribute("w", w);
        el.classList.add("icon--init");

        el.querySelector("a").addEventListener("click", function (evt) {
            if (!this.classList.contains("clickable")) {
                evt.preventDefault();
            }
        });
        el.addEventListener("mouseenter", function () {
            text.style.width = `${w}px`;
            el.classList.add("icon--in");
            setTimeout(function () {
                el.querySelector("a").classList.add("clickable");
            }, 1000);
        });
        el.addEventListener("mouseleave", function () {
            text.style.width = `5rem`;
            el.classList.remove("icon--in");
            el.querySelector("a").classList.remove("clickable");
        });
        setTimeout(function () {
            el.classList.add("icon--rotate");
            const deg = parseInt(el.getAttribute("data-rotate"), 10);
            console.log("deg", deg);
            el.querySelector(".icon__inner").setAttribute(
                "style",
                "transform: rotate(" + deg + "deg)"
            );
        }, 100);
        interact(el).draggable({
            inertia: true,
            modifiers: [
                interact.modifiers.restrictRect({
                    endOnly: true,
                }),
            ],
            autoScroll: true,
            // dragMoveListener from the dragging demo above
            listeners: {
                move: dragMoveListener,
            },
        });
    }, 1000);
};
window.addEventListener("DOMContentLoaded", function (event) {
    if (document.querySelector(".parallax")) {
        document.querySelector(".parallax").style.height = `${
            document.querySelector("main").getBoundingClientRect().height
        }px`;
    }
});

window.addEventListener("scroll", function (event) {
    var top = this.pageYOffset;
    var layers = document.getElementsByClassName("parallax");

    var layer, speed, yPos;
    for (var i = 0; i < layers.length; i++) {
        layer = layers[i];
        speed = layer.getAttribute("data-speed");
        yPos = -((top * speed) / 100);
        layer.setAttribute(
            "style",
            "height: " +
                (document.querySelector("main").getBoundingClientRect().height -
                    yPos) +
                "px; transform: translate3d(0px, " +
                yPos +
                "px, 0px)"
        );

        layer
            .querySelectorAll(".icon--rotate .icon__inner")
            .forEach(function (item) {
                const deg = parseInt(
                    item.parentNode.getAttribute("data-rotate"),
                    10
                );
                const newRotation = deg + yPos / 10;
                item.setAttribute(
                    "style",
                    "transform: rotate(" + newRotation + "deg)"
                );
            });
    }
});
